import React from "react";

import { faLightbulb } from "@fortawesome/pro-solid-svg-icons/faLightbulb";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "antd/es/tooltip";
import cn from "classnames";
import { useIntl } from "react-intl";

import { isMacOS } from "@mapmycustomers/shared/util/browser";

import Interactive from "@app/component/map/FeaturedMap/essentials/controls/Interactive";
import colors from "@app/styles/_colors.module.scss";

import styles from "./SelectionHint.module.scss";

interface Props {
  className?: string;
}

const SelectionHint: React.FC<Props> = ({ className }) => {
  const intl = useIntl();

  return (
    <Interactive className={cn(styles.container, className)}>
      <Tooltip
        color={colors.slate}
        overlayClassName={styles.tooltip}
        placement="leftTop"
        title={
          <div className={styles.tooltipContent}>
            <div className={styles.title}>
              {intl.formatMessage({
                id: "map.territories.topPanel.shortcutsHint.title",
                defaultMessage: "Smart Builder Shortcuts",
                description: "Shortcuts tooltip title in territory create/edit mode",
              })}
            </div>
            <div>
              {intl.formatMessage(
                {
                  id: "map.territories.topPanel.shortcutsHint.bulkAdd",
                  defaultMessage:
                    "Include multiple areas [{macOS, select, true {Shift ⇧} other {Shift}} + drag mouse]",
                  description: "Shortcuts tooltip line 1 in territory create/edit mode",
                },
                {
                  macOS: isMacOS(),
                }
              )}
            </div>
            <div>
              {intl.formatMessage(
                {
                  id: "map.territories.topPanel.shortcutsHint.bulkRemove",
                  defaultMessage:
                    "Exclude multiple areas [{macOS, select, true {Option ⌥} other {Alt}} + drag mouse]",
                  description: "Shortcuts tooltip line 2 in territory create/edit mode",
                },
                {
                  macOS: isMacOS(),
                }
              )}
            </div>
          </div>
        }
      >
        <div className={styles.circle}>
          <FontAwesomeIcon className={styles.icon} icon={faLightbulb} />
        </div>
      </Tooltip>
    </Interactive>
  );
};

export default SelectionHint;
